import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

/* Ambiente local de testes (opcional): REACT_APP_FIREBASE_EMULADORES=true em
   .env.development.local liga o app nos emuladores do Firebase, com um projeto
   "demo-" — que os emuladores garantem nunca alcançar serviços reais. Nenhum
   dado de produção é lido ou gravado nesse modo. Ver docs/mercado-pago.md. */
export const USANDO_EMULADORES = process.env.NODE_ENV !== "production" && process.env.REACT_APP_FIREBASE_EMULADORES === "true";

export const firebaseConfig = USANDO_EMULADORES ? {
  apiKey: "demo-api-key",
  authDomain: "demo-printcontrol.firebaseapp.com",
  projectId: "demo-printcontrol",
  storageBucket: "demo-printcontrol.appspot.com",
  appId: "1:000000000000:web:0000000000000000000000",
} : {
  apiKey: "AIzaSyAfa9eAFNJWhtSGEMw6Jsauf2234Jn6U9E",
  authDomain: "matriz3dsite.firebaseapp.com",
  projectId: "matriz3dsite",
  storageBucket: "matriz3dsite.firebasestorage.app",
  messagingSenderId: "282106794112",
  appId: "1:282106794112:web:55f7aca0593570f8889665",
  measurementId: "G-3LC9Z4PX5Z"
};

// Portas em firebase.json → "emulators"
export function conectarEmuladores(app, { auth, db } = {}) {
  if (!USANDO_EMULADORES) return;
  if (auth) connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  if (db) connectFirestoreEmulator(db, "127.0.0.1", 8085);
  connectFunctionsEmulator(getFunctions(app, "us-central1"), "127.0.0.1", 5001);
}

const app = initializeApp(firebaseConfig);

// Firestore com cache offline (persistência local). Mantém o app utilizável
// sem internet (ex.: bancada de impressão) e reduz leituras repetidas.
let _db;
try {
  _db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  });
} catch {
  // Ambiente sem IndexedDB (ou já inicializado): cai para o padrão
  _db = getFirestore(app);
}
export const db = _db;
export const auth = getAuth(app);
export const storage = getStorage(app);
conectarEmuladores(app, { auth, db });
